export default {
    setForm(state, form) {
        state.form = form;
    },
    setFormQuestions(state, form_questions) {
        state.form.form_questions = form_questions;
    }
};

